import { render, staticRenderFns } from "./CDialog.vue?vue&type=template&id=5df17f61&scoped=true"
import script from "./CDialog.vue?vue&type=script&lang=js"
export * from "./CDialog.vue?vue&type=script&lang=js"
import style0 from "./CDialog.vue?vue&type=style&index=0&id=5df17f61&prod&scoped=true&lang=css"
import style1 from "./CDialog.vue?vue&type=style&index=1&id=5df17f61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df17f61",
  null
  
)

export default component.exports